/* ============================================================
   MYNA — Cash on Delivery with a 20% online advance
   Works with the MYNA Cart Drawer v2 (#mc-drawer).
   Backend: COD_BACKEND/api/cod  (actions: advance-order, complete)
   Design: FINAL MYNA form + button standard (see alankar-tokens.css)
   ============================================================ */
(function () {
  'use strict';

  var COD_BACKEND = 'https://myna-login.vercel.app';
  var PREPAID_BACKEND = 'https://myna-backend.vercel.app';
  var ADVANCE_PCT = 20;

  // Advance = 20% of the total, but never below Rs 1 (Razorpay minimum) and never above the total.
  function advanceOf(total) {
    return Math.min(Math.round(total), Math.max(1, Math.round(total * ADVANCE_PCT / 100)));
  }

  function addHint(rel, href) {
    try { var l = document.createElement('link'); l.rel = rel; l.href = href; l.crossOrigin = 'anonymous'; document.head.appendChild(l); } catch (e) {}
  }
  addHint('preconnect', COD_BACKEND);
  addHint('preconnect', PREPAID_BACKEND);
  addHint('preconnect', 'https://checkout.razorpay.com');
  addHint('preconnect', 'https://api.razorpay.com');

  var rzpLoading = null;
  function loadRazorpay() {
    if (window.Razorpay) return Promise.resolve();
    if (rzpLoading) return rzpLoading;
    rzpLoading = new Promise(function (resolve, reject) {
      var sc = document.createElement('script');
      sc.src = 'https://checkout.razorpay.com/v1/checkout.js';
      sc.async = true;
      sc.onload = function () { resolve(); };
      sc.onerror = function () { rzpLoading = null; reject(new Error('rzp')); };
      document.head.appendChild(sc);
    });
    return rzpLoading;
  }

  var lastWarm = 0;
  function warmBackends() {
    var now = Date.now();
    loadRazorpay().catch(function () {});
    if (now - lastWarm < 20000) return;
    lastWarm = now;
    try { fetch(COD_BACKEND + '/api/cod', { method: 'GET', cache: 'no-store' }).catch(function () {}); } catch (e) {}
    try { fetch(PREPAID_BACKEND + '/api/create-razorpay-order', { method: 'GET', cache: 'no-store' }).catch(function () {}); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-myna-cart],[data-cart-toggle],#cart-icon-bubble,.cart-icon-bubble,.header__icon--cart,.alk-cart-btn,.js-cart-trigger,a[href="/cart"],.pdp-buy-btn,[data-buy-now],.alk-buy-now,.pdp-buynow,.myna-buy-now,#mc-checkout-btn')) {
      warmBackends();
    }
  }, true);
  (window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); })(function () { setTimeout(warmBackends, 1500); });

  var $ = function (id) { return document.getElementById(id); };
  function inr(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function calcTotals(c) {
    var total = (c.total_price || 0) / 100;
    var sub = (c.original_total_price || c.total_price || 0) / 100;
    return { sub: sub, disc: Math.max(0, sub - total), del: 0, total: total, qty: c.item_count || 0 };
  }
  function lineItems(c) {
    return (c.items || []).map(function (it) { return { variant_id: it.variant_id, quantity: it.quantity }; });
  }
  function api(payload) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 25000) : null;
    return fetch(COD_BACKEND + '/api/cod', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      if (timer) clearTimeout(timer);
      return r.json().catch(function () { return {}; });
    }, function (e) {
      if (timer) clearTimeout(timer);
      throw e;
    });
  }

  function injectStyles() {
    if ($('myna-cod-styles')) return;
    var s = document.createElement('style');
    s.id = 'myna-cod-styles';
    s.textContent = `
.myna-cod-open{margin-top:10px}
#myna-codm{position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483000;display:none;align-items:flex-end;justify-content:center;font-family:'Jost',sans-serif;color-scheme:dark}
#myna-codm.show{display:flex}
#myna-codm *{box-sizing:border-box}
#myna-codm .cm-bg{position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(5,5,5,.84)!important;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px)}
#myna-codm .cm-card{position:relative;display:flex;flex-direction:column;width:100%;max-width:440px;max-height:92vh;max-height:92dvh;background:linear-gradient(180deg,#151515 0%,#0a0a0a 100%)!important;color:#f5f1ea;border:1px solid rgba(245,241,234,.12);border-radius:22px 22px 0 0;box-shadow:0 -24px 70px rgba(0,0,0,.65);overflow:hidden}
@media(min-width:600px){#myna-codm{align-items:center}#myna-codm .cm-card{border-radius:22px;max-height:90vh}}
#myna-codm .cm-hd{position:relative;padding:24px 24px 16px;border-bottom:1px solid rgba(245,241,234,.08)}
#myna-codm .cm-ttl{font-family:'Cormorant Garamond',serif;font-weight:400;font-size:32px;line-height:1.08;margin:0 40px 6px 0;color:#f5f1ea!important}
#myna-codm .cm-ttl em{font-style:italic;color:#f5f1ea!important}
#myna-codm .cm-sub{font-size:13px;line-height:1.55;color:rgba(245,241,234,.62)!important;margin:0}
#myna-codm .cm-x{position:absolute;top:18px;right:18px;width:34px;height:34px;border-radius:50%;border:.5px solid rgba(245,241,234,.28)!important;background:rgba(255,255,255,.05)!important;color:#f5f1ea!important;font-size:18px;line-height:1;cursor:pointer;padding:0;min-height:0!important;box-shadow:none!important}
#myna-codm .cm-bd{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:18px 24px 6px;scrollbar-width:thin;scrollbar-color:rgba(245,241,234,.25) transparent}
#myna-codm .cm-grp{font-size:10.5px;letter-spacing:.24em;text-transform:uppercase;color:rgba(245,241,234,.5);margin:0 0 10px}
#myna-codm .cm-grp.n{margin-top:22px}
#myna-codm .cm-g{display:grid;grid-template-columns:1fr 1fr;gap:12px 10px}
#myna-codm .cm-f{display:flex;flex-direction:column;gap:6px;min-width:0}
#myna-codm .cm-f.full{grid-column:1/-1}
#myna-codm label{font-size:14px!important;letter-spacing:.03em;color:rgba(245,241,234,.82)!important;margin:0}
#myna-codm input,#myna-codm .cm-ph{height:52px;min-height:52px;border-radius:10px!important;background:linear-gradient(rgba(255,255,255,.1),rgba(255,255,255,.04))!important;border:.5px solid rgba(245,241,234,.28)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.14),0 8px 24px rgba(0,0,0,.4)!important;color:#f5f1ea!important;font-family:'Jost',sans-serif;font-size:13px!important;outline:none;margin:0;transition:border-color .3s,box-shadow .3s}
#myna-codm input{width:100%;padding:0 18px!important}
#myna-codm input::placeholder{color:rgba(245,241,234,.32)!important}
#myna-codm input:focus,#myna-codm .cm-ph:focus-within{border-color:#9caf88!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.14),0 0 0 3px rgba(156,175,136,.16),0 8px 24px rgba(0,0,0,.4)!important}
#myna-codm input.bad,#myna-codm .cm-ph.bad{border-color:#e8a87c!important}
#myna-codm .cm-ph{display:flex;align-items:center;padding:0}
#myna-codm .cm-ph span{padding:0 6px 0 18px;font-size:13px;color:rgba(245,241,234,.6)}
#myna-codm .cm-ph input{border:0!important;background:transparent!important;box-shadow:none!important;height:100%;min-height:0;padding:0 16px 0 6px!important}
#myna-codm .cm-ft{padding:16px 24px 22px;border-top:1px solid rgba(245,241,234,.08);background:#0a0a0a}
#myna-codm .cm-brk .r{display:flex;justify-content:space-between;font-size:13px;color:rgba(245,241,234,.7);padding:3px 0}
#myna-codm .cm-brk .r.now{color:#f5f1ea;font-weight:500;font-size:14px}
#myna-codm .cm-err{display:none;color:#e8a87c;font-size:13px;line-height:1.45;margin:10px 0 0;text-align:center}
#myna-codm .cm-err.on{display:block}
#myna-codm .cm-go{position:relative;display:flex;align-items:center;justify-content:space-between;width:100%;margin-top:12px;padding:0 24px;height:52px;cursor:pointer}
#myna-codm .cm-go .a{font-family:'Jost',sans-serif;font-size:14px;font-weight:500;margin-right:10px}
#myna-codm .cm-go .r2{display:flex;align-items:center}
#myna-codm .cm-go svg{width:18px;height:18px;stroke:currentColor;fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}
#myna-codm .cm-go[disabled]{opacity:.65;cursor:wait}
#myna-codm .cm-fine{display:flex;align-items:center;justify-content:center;gap:8px;font-size:11px;letter-spacing:.06em;color:rgba(245,241,234,.5);margin:12px 0 0}
#myna-codm .cm-ok{display:none;padding:34px 26px 30px;text-align:center}
#myna-codm .cm-ok .big{font-family:'Cormorant Garamond',serif;font-size:34px;font-weight:400;margin:0 0 10px;color:#f5f1ea!important}
#myna-codm .cm-ok .big em{font-style:italic}
#myna-codm .cm-ok p{font-size:14px;line-height:1.65;color:rgba(245,241,234,.75)!important;margin:6px 0}
#myna-codm .cm-ok .bal{margin:18px 0 4px;padding:14px;border:1px solid rgba(245,241,234,.14);border-radius:12px;background:rgba(245,241,234,.04)}
#myna-codm .cm-ok .bal b{display:block;font-family:'Cormorant Garamond',serif;font-size:28px;font-weight:500;color:#f5f1ea}
#myna-codm .cm-ok .done{margin-top:18px;width:100%;height:52px;cursor:pointer}
`;
    document.head.appendChild(s);
  }

  var RZP_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="rgba(245,241,234,.8)" aria-label="Razorpay"><path d="M22.436 0l-11.91 7.773-1.174 4.276 6.625-4.297L11.65 24h4.391l6.395-24zM14.26 10.098L3.389 17.166 1.564 24h9.008l3.688-13.902Z"/></svg>';

  function buildModal() {
    if ($('myna-codm')) return;
    injectStyles();
    var m = document.createElement('div');
    m.id = 'myna-codm';
    m.setAttribute('aria-hidden', 'true');
    m.innerHTML = `
<div class="cm-bg" id="myna-codm-bg"></div>
<div class="cm-card" role="dialog" aria-modal="true" aria-label="Confirm your order">
  <div id="myna-codm-form" style="display:flex;flex-direction:column;min-height:0;flex:1">
    <div class="cm-hd">
      <div class="cm-ttl">Confirm your <em>order</em></div>
      <p class="cm-sub">Pay ${ADVANCE_PCT}% online now to confirm. The rest is paid in cash when your order arrives.</p>
      <button class="cm-x" id="myna-codm-x" type="button" aria-label="Close">&times;</button>
    </div>
    <div class="cm-bd" id="myna-codm-bd">
      <div class="cm-g">
        <div class="cm-f full"><label for="myna-fName">Full name</label><input id="myna-fName" type="text" placeholder="As on your ID" autocomplete="name"></div>
        <div class="cm-f"><label for="myna-fPhone">Mobile number</label><div class="cm-ph" id="myna-phw"><span>+91</span><input id="myna-fPhone" type="tel" inputmode="numeric" placeholder="10-digit number" autocomplete="tel-national" maxlength="10"></div></div>
        <div class="cm-f"><label for="myna-fEmail">Email (optional)</label><input id="myna-fEmail" type="email" placeholder="you@email.com" autocomplete="email"></div>
      </div>
      <div class="cm-grp n">Delivery address</div>
      <div class="cm-g">
        <div class="cm-f full"><label for="myna-fFlat">House / flat no., building</label><input id="myna-fFlat" type="text" placeholder="e.g. 12, Shanti Apartments" autocomplete="address-line1"></div>
        <div class="cm-f full"><label for="myna-fArea">Area, street</label><input id="myna-fArea" type="text" placeholder="e.g. Vijay Nagar" autocomplete="address-line2"></div>
        <div class="cm-f full"><label for="myna-fLand">Landmark (optional)</label><input id="myna-fLand" type="text" placeholder="Near…"></div>
        <div class="cm-f"><label for="myna-fPin">Pincode</label><input id="myna-fPin" type="text" inputmode="numeric" placeholder="6 digits" autocomplete="postal-code" maxlength="6"></div>
        <div class="cm-f"><label for="myna-fCity">City</label><input id="myna-fCity" type="text" placeholder="City" autocomplete="address-level2"></div>
        <div class="cm-f full"><label for="myna-fState">State</label><input id="myna-fState" type="text" placeholder="State" autocomplete="address-level1"></div>
      </div>
      <div style="height:10px"></div>
    </div>
    <div class="cm-ft" id="myna-codm-ft">
      <div class="cm-brk">
        <div class="r"><span>Order total</span><span id="myna-cod-total">₹0</span></div>
        <div class="r now"><span>Pay now (${ADVANCE_PCT}% advance)</span><span id="myna-cod-now">₹0</span></div>
        <div class="r"><span>Pay on delivery</span><span id="myna-cod-later">₹0</span></div>
      </div>
      <div class="cm-err" id="myna-codm-err"></div>
      <button class="cm-go mc-mbtn" id="myna-codm-go" type="button"><span class="l">Pay advance &amp; place order</span><span class="r2"><span class="a" id="myna-codm-goamt"></span><svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span></button>
      <div class="cm-fine"><span>Payments secured by Razorpay</span>${RZP_ICON}</div>
    </div>
  </div>
  <div class="cm-ok" id="myna-codm-ok"></div>
</div>`;
    document.body.appendChild(m);
    $('myna-codm-x').addEventListener('click', closeModal);
    $('myna-codm-bg').addEventListener('click', closeModal);
    $('myna-codm-go').addEventListener('click', onGo);
    [].forEach.call(m.querySelectorAll('input'), function (i) {
      i.addEventListener('input', function () {
        i.classList.remove('bad');
        if (i.id === 'myna-fPhone') $('myna-phw').classList.remove('bad');
        if (i.id === 'myna-fPin') pinLookup();
        err('');
      });
    });
  }

  function pinLookup() {
    var v = digits(($('myna-fPin') || {}).value);
    if (v.length !== 6) return;
    try {
      fetch('https://api.postalpincode.in/pincode/' + v).then(function (r) { return r.json(); }).then(function (j) {
        var po = j && j[0] && j[0].PostOffice && j[0].PostOffice[0];
        if (!po) return;
        if (!$('myna-fCity').value) $('myna-fCity').value = po.District || po.Block || '';
        if (!$('myna-fState').value) $('myna-fState').value = po.State || '';
        $('myna-fCity').classList.remove('bad'); $('myna-fState').classList.remove('bad');
      }).catch(function () {});
    } catch (e) {}
  }

  var placed = false;
  function openModal() {
    buildModal();
    fetchCart().then(function (c) {
      var t = calcTotals(c);
      if (!t.qty) return;
      var adv = advanceOf(t.total);
      $('myna-cod-total').textContent = inr(t.total);
      $('myna-cod-now').textContent = inr(adv);
      $('myna-cod-later').textContent = inr(t.total - adv);
      $('myna-codm-goamt').textContent = inr(adv);
      err('');
      $('myna-codm-form').style.display = 'flex';
      $('myna-codm-ok').style.display = 'none';
      var m = $('myna-codm');
      m.classList.add('show'); m.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      loadRazorpay().catch(function () {});
    }).catch(function () {});
  }
  function closeModal() {
    var m = $('myna-codm'); if (!m) return;
    m.classList.remove('show'); m.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (placed) { placed = false; location.reload(); }
  }
  function err(msg) {
    var e = $('myna-codm-err'); if (!e) return;
    e.textContent = msg || '';
    e.classList.toggle('on', !!msg);
  }
  function busy(on) {
    var b = $('myna-codm-go'); if (!b) return;
    b.disabled = !!on;
    var l = b.querySelector('.l');
    if (l) l.textContent = on ? 'Please wait…' : 'Pay advance & place order';
  }

  function gatherCustomer() {
    return {
      name:  ($('myna-fName')  || {}).value || '',
      phone: digits(($('myna-fPhone') || {}).value).slice(-10),
      email: ($('myna-fEmail') || {}).value || ''
    };
  }
  function gatherAddress() {
    return {
      flat:     ($('myna-fFlat')  || {}).value || '',
      area:     ($('myna-fArea')  || {}).value || '',
      landmark: ($('myna-fLand')  || {}).value || '',
      city:     ($('myna-fCity')  || {}).value || '',
      state:    ($('myna-fState') || {}).value || '',
      pincode:  digits(($('myna-fPin') || {}).value).slice(0, 6)
    };
  }
  function findBad(cu, ad) {
    var bad = [];
    if (cu.name.trim().length < 2) bad.push('myna-fName');
    if (cu.phone.length !== 10) bad.push('myna-fPhone');
    if (ad.flat.trim().length < 3) bad.push('myna-fFlat');
    if (ad.area.trim().length < 3) bad.push('myna-fArea');
    if (ad.pincode.length !== 6) bad.push('myna-fPin');
    if (ad.city.trim().length < 2) bad.push('myna-fCity');
    if (ad.state.trim().length < 2) bad.push('myna-fState');
    ['myna-fName','myna-fPhone','myna-fFlat','myna-fArea','myna-fPin','myna-fCity','myna-fState'].forEach(function (id) {
      var el = $(id); if (el) el.classList.toggle('bad', bad.indexOf(id) > -1);
    });
    var pw = $('myna-phw'); if (pw) pw.classList.toggle('bad', bad.indexOf('myna-fPhone') > -1);
    return bad;
  }

  function showSuccess(orderName, later) {
    fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
    placed = true;
    $('myna-codm-form').style.display = 'none';
    var ok = $('myna-codm-ok');
    ok.style.display = 'block';
    ok.innerHTML = '<div class="big">Order <em>placed</em></div>' +
      '<p>' + (orderName ? 'Your order number is <strong>' + orderName + '</strong>.' : 'Thank you for your order.') + '</p>' +
      '<div class="bal"><span>Keep ready in cash on delivery</span><b>' + inr(later) + '</b></div>' +
      '<p>We will send a confirmation by SMS and email.</p>' +
      '<button class="done mc-mbtn" id="myna-codm-done" type="button" style="justify-content:center">Continue shopping</button>';
    $('myna-codm-done').addEventListener('click', closeModal);
  }

  function onGo() {
    var b = $('myna-codm-go');
    if (b && b.disabled) return;
    var cu = gatherCustomer(), ad = gatherAddress();
    var bad = findBad(cu, ad);
    if (bad.length) {
      err('Please complete the highlighted fields. Mobile must be 10 digits and pincode 6 digits.');
      var first = $(bad[0]);
      if (first && first.scrollIntoView) { try { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }
      if (first) first.focus();
      return;
    }
    err('');
    busy(true);
    loadRazorpay().catch(function () {});
    fetchCart().then(function (c) {
      var t = calcTotals(c);
      if (!t.qty) { busy(false); err('Your bag is empty.'); return; }
      var li = lineItems(c);
      var advance = advanceOf(t.total);
      api({ action: 'advance-order', amountPaise: advance * 100 }).then(function (o) {
        if (!o || !o.ok || !o.id) { busy(false); err('Unable to start the advance payment. Please try again.'); return; }
        openRazorpay(o, advance, cu, ad, li, t);
      }).catch(function () { busy(false); err('The server is taking too long. Please try again in a moment.'); });
    }).catch(function () { busy(false); err('Could not read your bag. Please try again.'); });
  }

  function openRazorpay(order, advance, cu, ad, li, totals) {
    var opts = {
      key: order.keyId,
      amount: order.amount,
      currency: 'INR',
      order_id: order.id,
      name: 'MYNA',
      description: 'COD advance (' + ADVANCE_PCT + '%), balance on delivery',
      prefill: { name: cu.name, email: cu.email, contact: cu.phone ? '+91' + cu.phone : '' },
      theme: { color: '#0a0a0a', backdrop_color: 'rgba(10,10,10,.88)' },
      redirect: false,
      handler: function (resp) {
        busy(true);
        api({
          action: 'complete',
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_signature: resp.razorpay_signature,
          customer: cu, address: ad, line_items: li, totals: totals,
          advancePaise: advance * 100
        }).then(function (res) {
          if (res && res.ok) { busy(false); showSuccess(res.order_name, totals.total - advance); }
          else { busy(false); err((res && res.error) || 'Payment received but the order failed. We will contact you shortly.'); }
        }).catch(function () { busy(false); err('Payment received but the order failed. We will contact you shortly.'); });
      },
      modal: { ondismiss: function () { busy(false); } }
    };
    function open() {
      var rzp = new Razorpay(opts);
      rzp.on('payment.failed', function () { busy(false); err('Payment failed. Please try again.'); });
      rzp.open();
    }
    loadRazorpay().then(open).catch(function () { busy(false); err('Payment gateway unavailable. Please refresh.'); });
  }

  function updateAmt() {
    var a = $('myna-cod-amt'), src = $('mc-ckamt');
    if (!a || !src) return;
    var n = parseInt(String(src.textContent).replace(/\D/g, ''), 10);
    if (!n) return;
    var t = '₹' + advanceOf(n).toLocaleString('en-IN') + ' now';
    if (a.textContent !== t) a.textContent = t;
  }
  function ensureButton() {
    var main = $('mc-checkout-btn');
    if (!main) return;
    if ($('myna-cod-open')) { updateAmt(); return; }
    injectStyles();
    var b = document.createElement('button');
    b.type = 'button';
    b.id = 'myna-cod-open';
    b.className = 'mc-mbtn myna-cod-open';
    b.innerHTML = '<span class="mc-shine"></span>' +
      '<span class="mc-mbtn-l">Cash on Delivery</span>' +
      '<span class="mc-mbtn-r"><span class="mc-mbtn-price" id="myna-cod-amt">₹0 now</span>' +
      '<svg class="mc-mbtn-arr" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>';
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openModal(); });
    main.parentNode.insertBefore(b, main.nextSibling);
    updateAmt();
  }
  var tries = 0;
  var iv = setInterval(function () { tries++; ensureButton(); if ($('myna-cod-open') || tries > 120) clearInterval(iv); }, 250);
  document.addEventListener('DOMContentLoaded', ensureButton);
  document.addEventListener('click', function () { setTimeout(ensureButton, 50); }, true);
  try {
    new MutationObserver(function () { ensureButton(); }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

/* Mobile-safe background scroll lock for the checkout drawer. */
(function () {
  'use strict';
  var locked = false, savedY = 0;
  function lock() {
    if (locked) return;
    savedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed'; b.style.top = (-savedY) + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%'; b.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    locked = true;
  }
  function unlock() {
    if (!locked) return;
    var b = document.body;
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = ''; b.style.overflow = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, savedY);
    locked = false;
  }
  function watch() {
    var d = document.getElementById('myna-drawer');
    if (!d) return false;
    var obs = new MutationObserver(function () { if (d.classList.contains('open')) lock(); else unlock(); });
    obs.observe(d, { attributes: true, attributeFilter: ['class'] });
    if (d.classList.contains('open')) lock();
    return true;
  }
  var t = 0, iv = setInterval(function () { t++; if (watch() || t > 40) clearInterval(iv); }, 250);
  if (document.readyState !== 'loading') watch();
  document.addEventListener('DOMContentLoaded', watch);
})();

/* PDP add-to-cart: intercept native form submit and add via AJAX so the drawer opens with no reload. */
(function () {
  'use strict';
  function ajaxAdd(form, goCheckout, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-loading'); }
    var addUrl = (window.routes && window.routes.cart_add_url) ? (window.routes.cart_add_url + '.js') : '/cart/add.js';
    var fd = new FormData(form);
    return fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json().catch(function () { return {}; }); })
      .then(function () {
        if (window.mynaOpenCart) window.mynaOpenCart();
        if (goCheckout) { setTimeout(function () { var s = document.getElementById('myna-toStep2'); if (s) s.click(); }, 420); }
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ajaxAdd(form, false, form.querySelector('button[type="submit"], [type="submit"]'));
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-buy-btn, [data-buy-now], .alk-buy-now, .pdp-buynow, .myna-buy-now');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ajaxAdd(form, false, btn);
  }, true);
})();
